import t from "./design-system.es58.js";
import { resolveComponent as l, openBlock as i, createElementBlock as s, renderSlot as a, createTextVNode as c, createVNode as f } from "vue";
/* empty css                    */
import p from "./design-system.es128.js";
const d = {
  name: "DsInlineAlertFooterLink",
  components: { Icon: t },
  props: {
    /**
     * URL user will be taken to when clicked
     */
    href: {
      type: String,
      required: !0
    }
  }
}, m = ["href"];
function _(o, e, n, u, k, I) {
  const r = l("Icon");
  return i(), s("a", {
    class: "inline-alert-footer-link",
    href: n.href,
    rel: "noopener noreferrer",
    target: "_blank"
  }, [
    a(o.$slots, "default", {}, void 0, !0),
    e[0] || (e[0] = c()),
    f(r, {
      class: "inline-alert-footer-link-icon",
      name: "external-link"
    })
  ], 8, m);
}
const v = /* @__PURE__ */ p(d, [["render", _], ["__scopeId", "data-v-8f6fd810"]]);
export {
  v as default
};
//# sourceMappingURL=design-system.es64.js.map
